module.exports = "/lucky-balls/img/jackpot/008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/008.png
// module id = 1108
// module chunks = 0